import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { API_SERVER_ADDRESS } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TrackingService {

  constructor(private http: HttpClient) { }

  /**
   * Obtiene la ubicación actual del bus basado en el identificador del planning actual.
   * Nueva aproximación RESTful: GET /api/v1/planning/:id/live-tracking
   */
  getBusLocationByPlanning(planningId: number | string): Observable<any> {
    return this.http.get(`${API_SERVER_ADDRESS}/v1/planning/${planningId}/live-tracking`).pipe(
      map((results: any) => results)
    );
  }

  /**
   * Legacy: Obtiene la ubicación directa del vehículo.
   */
  getBusGeoloc(vehicleRef: string): Observable<any> {
    return this.http.get(`${API_SERVER_ADDRESS}/v1/buses/${vehicleRef}/geoloc`).pipe(
      map((results: any) => results)
    );
  }
}
